import { Component } from 'react';

import s from './ErrorHandler.module.scss';

interface IState {
  error: Error | null;
}
export class ErrorHandler extends Component<unknown, IState> {
  constructor(props: unknown) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: Error): IState {
    return { error };
  }

  render(): JSX.Element {
    if (this.state.error) {
      return <span className={s.error}>{this.state.error.message}</span>;
    }

    // @ts-ignore incorrect types
    return this.props.children;
  }
}
